import React, { useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { Grid, Typography, Button } from "@material-ui/core";
import { LangContext } from "../../../Context/Langcontext";
import useReactRouter from "use-react-router";
import { useSpring, animated } from "react-spring";
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

const useStyle = makeStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
    backgroundColor: "#F0F0EA",
    paddingTop: "2.5rem",
    paddingBottom: "2.5rem",
  },
  btnstyle: {
    borderRadius: 8,
    padding: "0.5rem 3rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    marginTop: "2rem",
    "&:hover": {
      background: "#E16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  leftcomp: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  imgstyle: {
    width: "50%",
    height: "auto",
    padding: "2rem",
  },
  rightcomp: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  percentright: {
    height: "80%",
    width: "80%",
  },
  maintext: {
    fontWeight: 700,
    color: "#595A5A",
    fontSize: "2rem",
  },
  secondtext: {
    fontWeight: 200,
    color: "#595A5A",
    fontSize: "1rem",
    paddingTop: "1rem",
  },
}));
const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2];
const trans1 = (x, y) => `translate3d(${x / 10}px,${y / 10}px,0)`;

const AboutMEA = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { history } = useReactRouter();
  const [props, set] = useSpring(() => ({
    xy: [0, 0],
    config: { mass: 10, tension: 550, friction: 140 },
  }));

  return (
    <Grid container spacing={0} className={classes.root}>
      <Grid md={5} sm={12} item>
        <div
          className={classes.leftcomp}
          data-aos="fade-up"
          data-aos-anchor-placement="top-center"
          data-aos-duration="1000"
        >
          <animated.img
            onMouseMove={({ clientX: x, clientY: y }) =>
              set({ xy: calc(x, y) })
            }
            alt="about_api"
            className={classes.imgstyle}
            src={require("../../../images/graphic-icon/about_api.png")}
            style={{ transform: props.xy.interpolate(trans1) }}
          />
          {/* <img
           
          /> */}
        </div>
      </Grid>
      <Grid item md={7} sm={12}>
        <div className={classes.rightcomp}>
          <div className={classes.percentright}>
            <Typography className={classes.maintext}>
              {lang.About} MEA Map API
            </Typography>
            <Typography className={classes.secondtext}>
              {lang.SubtitlesAboutMEA}
            </Typography>
            {/* <Typography className={classes.secondtext}>
              Usu habeo equidem sanctus no. Suas summo id sed, erat erant
              oporteat cu pri. In eum omnes molestie. Sed ad debet scaevola, ne
              mel.
            </Typography> */}
            <Button
              className={classes.btnstyle}
              onClick={() => {
                history.push("/home/support");
                window.scrollTo(0, 0);
              }}
            >
              {lang.Contactus}
            </Button>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default AboutMEA;
